import React from "react";
import MachineAssets from "../components/production/machineassets/MachineAssets";

export default function MachineAssetsPage() {
    return <MachineAssets />;
}
